import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_MstGenogram = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_MstGenogram' className='file-pdf-document'>
            <div className='file-template'>




                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Family:</span></td>
                        <td className='w-250'><span className='eleHeader'>Therapist:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtFamily" name="txtFamily" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtTherapist" name="txtTherapist" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDate" name="txtDate" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center>
                        <b>Genogram</b>
                    </center>
                </p>
                <p className='w-750'>
                    <center>
                        <b>REASONS FOR REFERRAL</b>
                    </center>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Behavior:</span>
                    <span className='small'>(phys aggression, runaway, truancy, etc)</span>
                    <textarea id="txtBehavior" name="txtBehavior" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Frequency:</span>
                    <span className='small'>(how often does it occur?)</span>
                    <textarea id="txtFrequency" name="txtFrequency" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Intensity:</span>
                    <span className='small'>(how bad is it? describe)</span>
                    <textarea id="txtIntensity" name="txtIntensity" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Duration:</span>
                    <span className='small'>(how long has the problem existed?)</span>
                    <textarea id="txtDuration" name="txtDuration" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>System Affected:</span>
                    <span className='small'>(Individual, family, school, peer, community)</span>
                    <textarea id="txtSystemAffected" name="txtSystemAffected" className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <center>
                        <b>Initial Goals\Desired Outcome</b>
                    </center>
                </p>


                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>*Key Participant</span>
                            <span className='small'>(name)</span>
                        </td>
                        <td className='w-180'>
                            <span className='eleHeader'>Relationship to Youth</span>
                            <span className='small'>&nbsp;</span>
                        </td>
                        <td className='w-370'>
                            <span className='eleHeader'>Desired Outcome(s)</span>
                            <span className='small'>(what do you want to see by the end of treatment-in the next 3-5 months?)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_1" name="txtParticipant_1" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_1" name="txtRelationshi_1" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_1" name="txtDesiredOutc_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_2" name="txtParticipant_2" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_2" name="txtRelationshi_2" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_2" name="txtDesiredOutc_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_3" name="txtParticipant_3" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_3" name="txtRelationshi_3" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_3" name="txtDesiredOutc_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_4" name="txtParticipant_4" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_4" name="txtRelationshi_4" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_4" name="txtDesiredOutc_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_5" name="txtParticipant_5" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_5" name="txtRelationshi_5" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_5" name="txtDesiredOutc_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_6" name="txtParticipant_6" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_6" name="txtRelationshi_6" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_6" name="txtDesiredOutc_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_7" name="txtParticipant_7" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_7" name="txtRelationshi_7" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_7" name="txtDesiredOutc_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtParticipant_8" name="txtParticipant_8" className='add-only' />
                        </td>
                        <td className='w-180'>
                            <input type="text" id="txtRelationshi_8" name="txtRelationshi_8" className='add-only' />
                        </td>
                        <td className='w-370'>
                            <input type="text" id="txtDesiredOutc_8" name="txtDesiredOutc_8" className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>MST Therapist </b>

                    *ALL invested persons, including extended family supports, youth siblings, school staff, court staff / probation, MST therapist, Children's Services worker, etc.

                </p>


                <p className='w-750'>
                    <span className='eleHeader'>FAMILY:</span>
                    <span className='small'>(include caregiver
                        relationships, team
                        parenting, parenting styles,
                        level of conflict, extended
                        family support, etc.)



                    </span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id="txtFamilyStrengths" name="txtFamilyStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Systemic Weaknesses\Needs:</span>
                    <textarea id="txtFamilySystemicWeaknessesNeeds" name="txtFamilySystemicWeaknessesNeeds" className='add-only'></textarea>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>SCHOOL:</span>
                    <span className='small'>(include availability of
                        extracurricular activities,
                        academic assistance and
                        programming, home-school
                        communication, disciplinary
                        practices, etc.)
                    </span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id="txtSchoolStrengths" name="txtSchoolStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Systemic Weaknesses\Needs:</span>
                    <textarea id="txtSchoolSystemicWeaknessesNeeds" name="txtSchoolSystemicWeaknessesNeeds" className='add-only'></textarea>
                </p>



                <p className='w-750'>
                    <span className='eleHeader'>6. Barriers to Previous Intermediary Goals::</span>
                    <span className='small'>(Factors that interfered with the achievement (Met) of all your previous IG's above or new information you have acquired about things that will impede treatment progress overall.)Principle #8</span>
                    <textarea id="txtBarriersPreviousIntermediaryGoals" name="txtBarriersPreviousIntermediaryGoals" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>7. Advances in Treatment:</span>
                    <span className='small'>Gains that were made toward achieving last week's IG's or new information you
                        have acquired about things that will contribute to treatment progress.) Please explain how you met your goals
                        and provide the referenced documents (behavioral plan, safety plan, retrieval plan, etc) and how you will measure the
                        effectiveness of your interventions Principle#8.
                    </span>
                    <textarea id="txtAdvancesTreatment" name="txtAdvancesTreatment" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>8. Assessment of the “fit” between problems and their systemic context:</span>
                    <span className='small'>(Individual, Family, School, Peer, and
                        Community drivers (as evidenced by…)the justification of each driver within each context.
                        (Include only current fits or fits that apply to current presenting issue)
                    </span>
                    <textarea id="txtSystemicContext" name="txtSystemicContext" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>1) AEB:</span></td>
                        <td className='w-250'><span className='eleHeader'>2) AEB:</span></td>
                        <td className='w-250'><span className='eleHeader'>3) AEB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAeb_1" name="txtAeb_1" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtAeb_2" name="txtAeb_2" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtAeb_3" name="txtAeb_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>1. AEB:</span></td>
                        <td className='w-250'><span className='eleHeader'>2. AEB:</span></td>
                        <td className='w-250'><span className='eleHeader'>3. AEB:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAeb_4" name="txtAeb_4" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtAeb_5" name="txtAeb_5" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtAeb_6" name="txtAeb_6" className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>9. Intermediary Goals:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-30'><span className='eleHeader'>&nbsp;</span></td>
                        <td className='w-450'><span className='eleHeader'>Goals</span></td>
                        <td className='w-90'><span className='eleHeader'>Met</span></td>
                        <td className='w-90'><span className='eleHeader'>Partial</span></td>
                        <td className='w-90'><span className='eleHeader'>Not</span></td>
                    </tr>
                    <tr>
                        <td className='w-30'>IG 1 </td>
                        <td className='w-450'>
                            <input type="text" id="txtGoa_1" name="txtGoa_1" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtMet_1" name="txtMet_1" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtPar_1" name="txtPar_1" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtNot_1" name="txtNot_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>IG 2 </td>
                        <td className='w-450'>
                            <input type="text" id="txtGoa_2" name="txtGoa_2" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtMet_2" name="txtMet_2" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtPar_2" name="txtPar_2" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtNot_2" name="txtNot_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'>IG 3 </td>
                        <td className='w-450'>
                            <input type="text" id="txtGoa_3" name="txtGoa_3" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtMet_3" name="txtMet_3" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtPar_3" name="txtPar_3" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtNot_3" name="txtNot_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'></td>
                        <td className='w-450'>
                            <input type="text" id="txtGoa_4" name="txtGoa_4" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtMet_4" name="txtMet_4" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtPar_4" name="txtPar_4" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtNot_4" name="txtNot_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-30'></td>
                        <td className='w-450'>
                            <input type="text" id="txtGoa_5" name="txtGoa_5" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtMet_5" name="txtMet_5" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtPar_5" name="txtPar_5" className='add-only' /></td>
                        <td className='w-90'>
                            <input type="text" id="txtNot_5" name="txtNot_5" className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>10. Questions for supervision/consultation:</span>
                    <textarea id="txtQuestions" name="txtQuestions" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>11. Supervision Feedback:</span>
                    <textarea id="txtSupervisionFeedback" name="txtSupervisionFeedback" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>12. Consultation Feedback:</span>
                    <textarea id="txtConsultationFeedback" name="txtConsultationFeedback" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-500">Supervisor Signature:</td>
                        <td className="small w-250">Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-500">MST Therapist Signature:</td>
                        <td className="small w-250">Date:</td>
                    </tr>
                </table>
                
            </div>
        </form>

    )
}  
